<template>
    <div >
  <top-navbar ></top-navbar>
  <div class=" mb-5  background_color">
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6    class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Manage Customer</h6>

    <div  class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" class="bdr-rad " v-model="filter" type="search" placeholder="Search">
            </b-form-input>

    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
        <span class="custom-breadcrumb">Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</span>
    </div>

        </div>


      <div class="d-grid gap-2 d-md-flex justify-content-md-end ">


        <button  @click="customerCreate()"  class="btn btn-sm btn-outline-primary  mb-1 mt-0 bdr-rad">  Create Customer</button>


      </div>
    </div>
   <div  class="card bdr-rad2 mt-1 shadow p-2  ">
    <div  class="card-body " >
      <div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>




       <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">

    <div class="d-flex  ">

    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->

  <div class="table-responsive">


    <b-table responsive style="font-size: small;"   class="table-hover "
      :items="mcustomers"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      head-variant="dark"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"


      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"

      show-empty
      small
      @filtered="onFiltered"
    >

    <!-- <template #thead-top="data">
      <b-tr>
        <b-th class="custom-header">Code</b-th>
        <b-th class="custom-header">Dealer Name</b-th>
        <b-th class="custom-header">Address Line 1</b-th>
        <b-th class="custom-header">Address Line 2</b-th>
        <b-th class="custom-header">Address Line 3</b-th>
        <b-th class="custom-header">Address Line 4</b-th>

        <b-th class="custom-header">Actions</b-th>
      </b-tr>
    </template> -->



      <!-- <template #cell(C_name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template> -->

      <template #cell(actions)="row">

        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor"@click="moreinfo(row.item.idCustomer)">View</a>
    <a class="dropdown-item mouse-cursor" @click="Update(row.item.idCustomer)">Update</a>

  </div>
</div>


    <!-- <div >
  <b-dropdown  size="sm" id="dropdown-left" text="Action" variant="outline-primary" class=" dropdown-shadow bdr-rad">
    <b-dropdown-item @click="moreinfo(row.item.idCustomer)">View</b-dropdown-item>
    <b-dropdown-item @click="Update(row.item.idCustomer)">Update</b-dropdown-item>
  </b-dropdown>
</div> -->


      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>



    <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
      <!-- <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination> -->
      <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
    </b-col>


</div>
  </div>

  <b-modal   :id="infoModal.id" :title="infoModal.content.C_code"  hide-footer >
    <div class="card">
      <div class="card-body">




      </div>
    </div>

  </b-modal>

</div>
</div>

<br><br>

</div>
  </div>

  <content-footer></content-footer>
</div>


  </template>

  <script>
   //import {   CButton, } from '@coreui/vue';
   //import httpClient from '@/axios';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'




  export default {
    components :{

        TopNavbar,
        ContentFooter,

    },

      mounted(){
    this.loadMiinventory()
      },

      computed: {




      },

      data(){
      return{

        mcustomers:[],
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],

        fields: [
          { key: 'C_code', label: 'Code', sortable: true, sortDirection: 'desc' },
          { key: 'C_name', label: 'Dealer Name', sortable: true,  },
          { key: 'C_address_line1', label: 'Address Line 1', sortable: true  },
          { key: 'C_address_line2', label: 'Address Line 2', sortable: true  },
          { key: 'C_address_line3', label: 'Address Line 3', sortable: true  },
          { key: 'C_address_line4', label: 'Country', sortable: true  },
          { key: '', label: 'Status', sortable: true  },
          { key: '', label: 'Created By', sortable: true ,  },


          { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],

        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        isLoading: true,


      };
      },




     methods:{

      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',

        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)


    } catch (error) {
      console.log(error.response);
    }
  },

  async moreinfo(idCustomer) {

    this.$router.push('/mcustomer/view?id='+idCustomer);

  },
  async customerCreate() {

  this.$router.push('/mcustomer/create');

},
  async Update(id){
        this.$router.push('/mcustomer/update?id='+id);
      },

      serchCustom(id) {

    this.filterOn = id;
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      async loadMiinventory() {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/mcustomer/index',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.mcustomers = data.item_list;
         this.totalRows = this.mcustomers.length;
         this.isLoading= false;

      } catch (error) {
        console.log(error.response);
      }
    },








  }




  };

  </script>

  <style scoped>
  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }

  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #007bff;
      border-top: 2px solid #007bff;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
      .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;

      }
      .decoration{
      text-decoration: none;
      color:white !important;
    }
    .width7{
      width: 250px;
    }

    .custom-header {
  background-color: #63adfc !important;
  color: white !important;

}
.bdr-rad{
  border-radius: 12px;
}
.bdr-rad2{
  border-radius: 15px;
}


.bg-clr1{
  background-color: red !important;
}
 .mouse-cursor {
  cursor: pointer;
 }











  </style>
